/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface MapView {
  listSize: string;
  mapSize: string;
}

export interface Coordinates {
  lat: number;
  lng: number;
}

@Injectable({
  providedIn: 'root'
})
export class MapService {

  // Default map values
  private _zoom: Subject<number> = new Subject();
  private _coordinates: Subject<Coordinates> = new Subject();
  private _mapView: Subject<MapView> = new Subject();


  constructor() { }

  getMapView() {
    return this._mapView.asObservable();
  }

  getCoordinates() {
    return this._coordinates.asObservable();
  }

  getZoom() {
    return this._zoom.asObservable();
  }

  showMap() {
    this._mapView.next({
      listSize: '0',
      mapSize: '12'
    });
  }

  showList() {
    this._mapView.next({
      listSize: '12',
      mapSize: '0'
    });
  }

  setCoordinates(coordinates: Coordinates) {
    this._coordinates.next(coordinates);
  }

  setZoom(zoom: number) {
    this._zoom.next(zoom);
  }
}
